// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.video-test-poll__progress.is-progress-bar::after {\n  background-color: transparent;\n}\n", ""]);
// Exports
module.exports = exports;
